<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1">CONTENTS</h1>
<nav epub:type="toc" id="toc">
<ol class="tocol">
<li class="table-of-content">
<a href="#/0_chapter2701giftbeforeparting">CHAPTER 2701 - GIFT BEFORE PARTING</a>
</li>
<li class="table-of-content">
<a href="#/1_chapter2702mysteriousskyevilemperor">CHAPTER 2702 - MYSTERIOUS SKY EVIL EMPEROR</a>
</li>
<li class="table-of-content">
<a href="#/2_chapter2703confrontationforthesamerealm">CHAPTER 2703 - CONFRONTATION FOR THE SAME REALM</a>
</li>
<li class="table-of-content">
<a href="#/3_chapter2704achoiceofhelplessness">CHAPTER 2704 - A CHOICE OF HELPLESSNESS</a>
</li>
<li class="table-of-content">
<a href="#/4_chapter2705riskingoneslife">CHAPTER 2705 - RISKING ONE'S LIFE</a>
</li>
<li class="table-of-content">
<a href="#/5_chapter2706strugglewithallyourmight">CHAPTER 2706 - STRUGGLE WITH ALL YOUR MIGHT</a>
</li>
<li class="table-of-content">
<a href="#/6_chapter2707heavenlysound">CHAPTER 2707 - HEAVENLY SOUND</a>
</li>
<li class="table-of-content">
<a href="#/7_chapter2708tibetandragoncrouchingtiger">CHAPTER 2708 - TIBETAN DRAGON CROUCHING TIGER</a>
</li>
<li class="table-of-content">
<span href="#/8_chapter2709escapefromdeath" title="Link target outside of Sample">CHAPTER 2709 - ESCAPE FROM DEATH!</span>
</li>
<li class="table-of-content">
<span href="#/9_chapter2710fullofgratitude" title="Link target outside of Sample">CHAPTER 2710 - FULL OF GRATITUDE</span>
</li>
<li class="table-of-content">
<span href="#/10_chapter2711threebreaksoflife" title="Link target outside of Sample">CHAPTER 2711 - THREE BREAKS OF LIFE</span>
</li>
<li class="table-of-content">
<span href="#/11_chapter2712thetruthofannihilation" title="Link target outside of Sample">CHAPTER 2712 - THE TRUTH OF ANNIHILATION</span>
</li>
<li class="table-of-content">
<span href="#/12_chapter2713thesecondheavenlylayer" title="Link target outside of Sample">CHAPTER 2713 - THE SECOND HEAVENLY LAYER</span>
</li>
<li class="table-of-content">
<span href="#/13_chapter2714amutualfriendshipwithoutafight" title="Link target outside of Sample">CHAPTER 2714 - A MUTUAL FRIENDSHIP WITHOUT A FIGHT</span>
</li>
<li class="table-of-content">
<span href="#/14_chapter2715dragoncave" title="Link target outside of Sample">CHAPTER 2715 - DRAGON CAVE</span>
</li>
<li class="table-of-content">
<span href="#/15_chapter2716unknowndanger" title="Link target outside of Sample">CHAPTER 2716 - UNKNOWN DANGER</span>
</li>
<li class="table-of-content">
<span href="#/16_chapter2717culinarypavilion" title="Link target outside of Sample">CHAPTER 2717 - CULINARY PAVILION</span>
</li>
<li class="table-of-content">
<span href="#/17_chapter2718odontoplasty" title="Link target outside of Sample">CHAPTER 2718 - ODONTOPLASTY</span>
</li>
<li class="table-of-content">
<span href="#/18_chapter2719congregationsoftheascendants" title="Link target outside of Sample">CHAPTER 2719 - CONGREGATIONS OF THE ASCENDANTS</span>
</li>
<li class="table-of-content">
<span href="#/19_chapter2720devoidheavenlybook" title="Link target outside of Sample">CHAPTER 2720 - DEVOID HEAVENLY BOOK</span>
</li>
<li class="table-of-content">
<span href="#/20_chapter2721strugglefor" title="Link target outside of Sample">CHAPTER 2721 - STRUGGLE FOR</span>
</li>
<li class="table-of-content">
<span href="#/21_chapter2722exaltedcelestialsixdesire" title="Link target outside of Sample">CHAPTER 2722 - EXALTED CELESTIAL SIX-DESIRE</span>
</li>
<li class="table-of-content">
<span href="#/22_chapter2723concealmentofidentity" title="Link target outside of Sample">CHAPTER 2723 - CONCEALMENT OF IDENTITY</span>
</li>
<li class="table-of-content">
<span href="#/23_chapter2724found" title="Link target outside of Sample">CHAPTER 2724 - FOUND</span>
</li>
<li class="table-of-content">
<span href="#/24_chapter2725followclosely" title="Link target outside of Sample">CHAPTER 2725 - FOLLOW CLOSELY</span>
</li>
<li class="table-of-content">
<span href="#/25_chapter2726draconicbeast" title="Link target outside of Sample">CHAPTER 2726 - DRACONIC BEAST</span>
</li>
<li class="table-of-content">
<span href="#/26_chapter2727inspection" title="Link target outside of Sample">CHAPTER 2727 - INSPECTION</span>
</li>
<li class="table-of-content">
<span href="#/27_chapter2728darkdecision" title="Link target outside of Sample">CHAPTER 2728 - DARK DECISION</span>
</li>
<li class="table-of-content">
<span href="#/28_chapter2729waitingalongtime" title="Link target outside of Sample">CHAPTER 2729 - WAITING A LONG TIME</span>
</li>
<li class="table-of-content">
<span href="#/29_chapter2730headtoheadcontention" title="Link target outside of Sample">CHAPTER 2730 - HEAD-TO-HEAD CONTENTION</span>
</li>
<li class="table-of-content">
<span href="#/30_chapter2731outbreakofblackwater" title="Link target outside of Sample">CHAPTER 2731 - OUTBREAK OF BLACK WATER</span>
</li>
<li class="table-of-content">
<span href="#/31_chapter2732cardcollision" title="Link target outside of Sample">CHAPTER 2732 - CARD COLLISION</span>
</li>
<li class="table-of-content">
<span href="#/32_chapter2733giveittome" title="Link target outside of Sample">CHAPTER 2733 - GIVE IT TO ME</span>
</li>
<li class="table-of-content">
<span href="#/33_chapter2734generalledger" title="Link target outside of Sample">CHAPTER 2734 - GENERAL LEDGER</span>
</li>
<li class="table-of-content">
<span href="#/34_chapter2735bullman" title="Link target outside of Sample">CHAPTER 2735 - BULLMAN</span>
</li>
<li class="table-of-content">
<span href="#/35_chapter2736matrixbreakdown" title="Link target outside of Sample">CHAPTER 2736 - MATRIX BREAKDOWN</span>
</li>
<li class="table-of-content">
<span href="#/36_chapter2737enemyslaughtering" title="Link target outside of Sample">CHAPTER 2737 - ENEMY SLAUGHTERING</span>
</li>
<li class="table-of-content">
<span href="#/37_chapter2738tobrandishtheswordbrazenly" title="Link target outside of Sample">CHAPTER 2738 - TO BRANDISH THE SWORD BRAZENLY</span>
</li>
<li class="table-of-content">
<span href="#/38_chapter2739facesmacking" title="Link target outside of Sample">CHAPTER 2739 - FACE-SMACKING</span>
</li>
<li class="table-of-content">
<span href="#/39_chapter2740imprint" title="Link target outside of Sample">CHAPTER 2740 - IMPRINT</span>
</li>
<li class="table-of-content">
<span href="#/40_chapter2741greatemperorofthesevensentiments" title="Link target outside of Sample">CHAPTER 2741 - GREAT EMPEROR OF THE SEVEN SENTIMENTS</span>
</li>
<li class="table-of-content">
<span href="#/41_chapter2742adarkrumor" title="Link target outside of Sample">CHAPTER 2742 - A DARK RUMOR</span>
</li>
<li class="table-of-content">
<span href="#/42_chapter2743carmine" title="Link target outside of Sample">CHAPTER 2743 - CARMINE</span>
</li>
<li class="table-of-content">
<span href="#/43_chapter2744fourkindsofdanger" title="Link target outside of Sample">CHAPTER 2744 - FOUR KINDS OF DANGER</span>
</li>
<li class="table-of-content">
<span href="#/44_chapter2745dragonsmight" title="Link target outside of Sample">CHAPTER 2745 - DRAGON'S MIGHT</span>
</li>
<li class="table-of-content">
<span href="#/45_chapter2746hopeforlife" title="Link target outside of Sample">CHAPTER 2746 - HOPE FOR LIFE</span>
</li>
<li class="table-of-content">
<span href="#/46_chapter2747sinopotamon" title="Link target outside of Sample">CHAPTER 2747 - SINOPOTAMON</span>
</li>
<li class="table-of-content">
<span href="#/47_chapter2748nowayback" title="Link target outside of Sample">CHAPTER 2748 - NO WAY BACK</span>
</li>
<li class="table-of-content">
<span href="#/48_chapter2749fadedblackdragon" title="Link target outside of Sample">CHAPTER 2749 - FADED BLACK DRAGON</span>
</li>
<li class="table-of-content">
<span href="#/49_chapter2750reversescale" title="Link target outside of Sample">CHAPTER 2750 - REVERSE SCALE</span>
</li>
<li class="table-of-content">
<span href="#/50_chapter2751themetamorphosebookofheavensbook" title="Link target outside of Sample">CHAPTER 2751 - THE METAMORPHOSE BOOK OF HEAVEN'S BOOK</span>
</li>
<li class="table-of-content">
<span href="#/51_chapter2752demonicqibodytempering" title="Link target outside of Sample">CHAPTER 2752 - DEMONIC QI BODY TEMPERING</span>
</li>
<li class="table-of-content">
<span href="#/52_chapter2753indestructiblediamond" title="Link target outside of Sample">CHAPTER 2753 - INDESTRUCTIBLE DIAMOND</span>
</li>
<li class="table-of-content">
<span href="#/53_chapter2754thickfightingspirit" title="Link target outside of Sample">CHAPTER 2754 - THICK FIGHTING SPIRIT</span>
</li>
<li class="table-of-content">
<span href="#/54_chapter2755late" title="Link target outside of Sample">CHAPTER 2755 - LATE</span>
</li>
<li class="table-of-content">
<span href="#/55_chapter2756oprol" title="Link target outside of Sample">CHAPTER 2756 - OPROL</span>
</li>
<li class="table-of-content">
<span href="#/56_chapter2757peachoutoftheworld" title="Link target outside of Sample">CHAPTER 2757 - PEACH OUT OF THE WORLD</span>
</li>
<li class="table-of-content">
<span href="#/57_chapter2758distress" title="Link target outside of Sample">CHAPTER 2758 - DISTRESS</span>
</li>
<li class="table-of-content">
<span href="#/58_chapter2759itisimperative" title="Link target outside of Sample">CHAPTER 2759 - IT IS IMPERATIVE</span>
</li>
<li class="table-of-content">
<span href="#/59_chapter2760windregion" title="Link target outside of Sample">CHAPTER 2760 - WIND REGION</span>
</li>
<li class="table-of-content">
<span href="#/60_chapter2761aoliesappearance" title="Link target outside of Sample">CHAPTER 2761 - AO LIE'S APPEARANCE</span>
</li>
<li class="table-of-content">
<span href="#/61_chapter2762brightcontrast" title="Link target outside of Sample">CHAPTER 2762 - BRIGHT CONTRAST</span>
</li>
<li class="table-of-content">
<span href="#/62_chapter2763failure" title="Link target outside of Sample">CHAPTER 2763 - FAILURE</span>
</li>
<li class="table-of-content">
<span href="#/63_chapter2764spirituallightsemerge" title="Link target outside of Sample">CHAPTER 2764 - SPIRITUAL LIGHTS EMERGE</span>
</li>
<li class="table-of-content">
<span href="#/64_chapter2765whoisanant" title="Link target outside of Sample">CHAPTER 2765 - WHO IS AN ANT?</span>
</li>
<li class="table-of-content">
<span href="#/65_chapter2766madstruggle" title="Link target outside of Sample">CHAPTER 2766 - MAD STRUGGLE</span>
</li>
<li class="table-of-content">
<span href="#/66_chapter2767worldcrash" title="Link target outside of Sample">CHAPTER 2767 - WORLD CRASH</span>
</li>
<li class="table-of-content">
<span href="#/67_chapter2768oxaproxil" title="Link target outside of Sample">CHAPTER 2768 - OXAPROXIL</span>
</li>
<li class="table-of-content">
<span href="#/68_chapter2769aoliefalling" title="Link target outside of Sample">CHAPTER 2769 - AO LIE FALLING</span>
</li>
<li class="table-of-content">
<span href="#/69_chapter2770dispute" title="Link target outside of Sample">CHAPTER 2770 - DISPUTE</span>
</li>
<li class="table-of-content">
<span href="#/70_chapter2771mixedfeelings" title="Link target outside of Sample">CHAPTER 2771 - MIXED FEELINGS</span>
</li>
<li class="table-of-content">
<span href="#/71_chapter2772avoidingsharpedge" title="Link target outside of Sample">CHAPTER 2772 - AVOIDING SHARP EDGE</span>
</li>
<li class="table-of-content">
<span href="#/72_chapter2773escapebyforce" title="Link target outside of Sample">CHAPTER 2773 - ESCAPE BY FORCE</span>
</li>
<li class="table-of-content">
<span href="#/73_chapter2774seethesunagain" title="Link target outside of Sample">CHAPTER 2774 - SEE THE SUN AGAIN</span>
</li>
<li class="table-of-content">
<span href="#/74_chapter2775fengliuyunsan" title="Link target outside of Sample">CHAPTER 2775 - FENG LIUYUN SAN</span>
</li>
<li class="table-of-content">
<span href="#/75_chapter2776farewelltoalteringteeth" title="Link target outside of Sample">CHAPTER 2776 - FAREWELL TO ALTERING TEETH</span>
</li>
<li class="table-of-content">
<span href="#/76_chapter2777longmenmessage" title="Link target outside of Sample">CHAPTER 2777 - LONGMEN MESSAGE</span>
</li>
<li class="table-of-content">
<span href="#/77_chapter2778toothtransferring" title="Link target outside of Sample">CHAPTER 2778 - TOOTH TRANSFERRING</span>
</li>
<li class="table-of-content">
<span href="#/78_chapter2779universalbirth" title="Link target outside of Sample">CHAPTER 2779 - UNIVERSAL BIRTH</span>
</li>
<li class="table-of-content">
<span href="#/79_chapter2780twoeagleswithonearrow" title="Link target outside of Sample">CHAPTER 2780 - TWO EAGLES WITH ONE ARROW</span>
</li>
<li class="table-of-content">
<span href="#/80_chapter2781lotusseedformation" title="Link target outside of Sample">CHAPTER 2781 - LOTUS SEED FORMATION</span>
</li>
<li class="table-of-content">
<span href="#/81_chapter2782bloodytruth" title="Link target outside of Sample">CHAPTER 2782 - BLOODY TRUTH</span>
</li>
<li class="table-of-content">
<span href="#/82_chapter2783sixthlevelofthedragoncave" title="Link target outside of Sample">CHAPTER 2783 - SIXTH LEVEL OF THE DRAGON CAVE</span>
</li>
<li class="table-of-content">
<span href="#/83_chapter2784phenomenaleruption" title="Link target outside of Sample">CHAPTER 2784 - PHENOMENAL ERUPTION</span>
</li>
<li class="table-of-content">
<span href="#/84_chapter2785mixingwiththedragonisland" title="Link target outside of Sample">CHAPTER 2785 - MIXING WITH THE DRAGON ISLAND</span>
</li>
<li class="table-of-content">
<span href="#/85_chapter2786longmenpresent" title="Link target outside of Sample">CHAPTER 2786 - LONGMEN PRESENT</span>
</li>
<li class="table-of-content">
<span href="#/86_chapter2787twindragonday" title="Link target outside of Sample">CHAPTER 2787 - TWIN DRAGON DAY</span>
</li>
<li class="table-of-content">
<span href="#/87_chapter2788fightingbegins" title="Link target outside of Sample">CHAPTER 2788 - FIGHTING BEGINS</span>
</li>
<li class="table-of-content">
<span href="#/88_chapter2789denglongmen" title="Link target outside of Sample">CHAPTER 2789 - DENGLONGMEN</span>
</li>
<li class="table-of-content">
<span href="#/89_chapter2790competitionsforkarmicluck" title="Link target outside of Sample">CHAPTER 2790 - COMPETITIONS FOR KARMIC LUCK</span>
</li>
<li class="table-of-content">
<span href="#/90_chapter2791bloodlinepromotion" title="Link target outside of Sample">CHAPTER 2791 - BLOODLINE PROMOTION</span>
</li>
<li class="table-of-content">
<span href="#/91_chapter2792counterattack" title="Link target outside of Sample">CHAPTER 2792 - COUNTERATTACK</span>
</li>
<li class="table-of-content">
<span href="#/92_chapter2793hatingseed" title="Link target outside of Sample">CHAPTER 2793 - HATING SEED</span>
</li>
<li class="table-of-content">
<span href="#/93_chapter2794celestiallordofthestars" title="Link target outside of Sample">CHAPTER 2794 - CELESTIAL LORD OF THE STARS</span>
</li>
<li class="table-of-content">
<span href="#/94_chapter2795falsebravado" title="Link target outside of Sample">CHAPTER 2795 - FALSE BRAVADO?</span>
</li>
<li class="table-of-content">
<span href="#/95_chapter2796thetidehasdropped" title="Link target outside of Sample">CHAPTER 2796 - THE TIDE HAS DROPPED</span>
</li>
<li class="table-of-content">
<span href="#/96_chapter2797dogbitedog" title="Link target outside of Sample">CHAPTER 2797 - DOG BITE DOG</span>
</li>
<li class="table-of-content">
<span href="#/97_chapter2798karmickarmickarmicdragon" title="Link target outside of Sample">CHAPTER 2798 - KARMIC KARMIC KARMIC DRAGON</span>
</li>
<li class="table-of-content">
<span href="#/98_chapter2799massemergence" title="Link target outside of Sample">CHAPTER 2799 - MASS EMERGENCE</span>
</li>
<li class="table-of-content">
<span href="#/99_chapter2800everyonewasshocked" title="Link target outside of Sample">CHAPTER 2800 - EVERYONE WAS SHOCKED</span>
</li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?696373f0